export default function($) {
    let programsSwiper = document.querySelector('.js-programs-slider');
  const postsSwiper = new Swiper('.js-posts-slider', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".posts-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      1248: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
  });

 const programsSwiperParams = {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".programs-swiper-pagination",
      clickable: true,
      type: 'fraction',
    },
    loop: true,
    breakpoints: {
      480: {
        slidesPerView: 2,
        spaceBetween: 32,
        loop: false,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
        loop: false,
      }
    },
    on: {
      destroy: function() {
        $('.programs-swiper-pagination').hide();
      },
      init: function() {
        $('.programs-swiper-pagination').show();

      },
    },
  };


  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setLinearEasing() { this.wrapperEl.style.transitionTimingFunction = 'linear'; }

  const infiniteAutoplayOn = { init: setLinearEasing, transitionStart: setLinearEasing };

  const infiniteAutoplayConfig = {
    delay: 0,
    disableOnInteraction: false,
  };

  const partnersSwiper = new Swiper('.js-partners-slider', {
    slidesPerView: 4,
    spaceBetween: 48,
    loop: true,
    speed: prefersReducedMotion ? 0 : 3000,
    autoplay: prefersReducedMotion ? false : infiniteAutoplayConfig,
    breakpoints: {
      480: {
        slidesPerView: 5,
        spaceBetween: 48,
      },
      1024: {
        slidesPerView: 8,
        spaceBetween: 64,
      },
      1280: {
        slidesPerView: 10,
        spaceBetween: 72,
      },
      1536: {
        slidesPerView: 10,
        spaceBetween: 80,
      },
      1920: {
        slidesPerView: 10,
        spaceBetween: 128,
      }
    },
    on: prefersReducedMotion ? {} : infiniteAutoplayOn,
  });

  const certificationsSwiper = new Swiper('.js-certifications-slider', {
    slidesPerView: 4,
    spaceBetween: 48,
    loop: true,
    speed: prefersReducedMotion ? 0 : 3000,
    autoplay: prefersReducedMotion ? false : infiniteAutoplayConfig,
    breakpoints: {
      480: {
        slidesPerView: 5,
        spaceBetween: 48,
      },
      1024: {
        slidesPerView: 8,
        spaceBetween: 64,
      },
      1280: {
        slidesPerView: 10,
        spaceBetween: 72,
      },
      1536: {
        slidesPerView: 10,
        spaceBetween: 80,
      },
      1920: {
        slidesPerView: 10,
        spaceBetween: 128,
      }
    },
    on: prefersReducedMotion ? {} : infiniteAutoplayOn,
  });

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( $('.js-programs-slider').length > 0 && !programsSwiper.initialized ) {
        programsSwiper = new Swiper('.js-programs-slider', programsSwiperParams);
      }
    }
    else {
      if( $('.js-programs-slider').length > 0 && programsSwiper.initialized ) {
        programsSwiper.destroy(false,true);
        $('.js-programs-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.programs-swiper-pagination').hide();
      }
    }
  }
};
